import store from 'foremanReact/redux';
import { addToast } from 'foremanReact/components/ToastsList';

export const showToast = toast => store.dispatch(addToast(toast));



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/toastHelper.js